import {AudiometriaTonal} from '@shared/forms/templates/exams-config/config-class/AUDIO-audiometria-tonal.config';
import {EstudioCuestionarioDireccionadoMMSS} from '@shared/forms/templates/exams-config/config-class/PFYGR-cuestionario-direccionado-mmss.config';
import {EstudioAumentoPresionVenosa} from './config-class/VMMII-aumento-presion-venosa-mmii.config';
import {ExamenGenerico} from './config-class/EST-generico.config';
import { EstudioSUV } from '@app/shared/forms/templates/exams-config/config-class/ORL-sobrecarga-uso-voz.config';
import { EstudioColumnaLumbosacra } from '@app/shared/forms/templates/exams-config/config-class/COLUM-columna-lumbosacra.config';
import { EstudioEvaluacionDermatologica } from '@app/shared/forms/templates/exams-config/config-class/DERM-evaluacion-dermatologica.config';
import {ExamenIluminacionInsuficiente} from './config-class/ILUMI-iluminacion-insuficiente.config';
import {EstudioHistoriaClinica} from './config-class/HC-historia-clinica.config';

export class ExamsByCode {
  public data = {
    DERM: {
      id: 3,
      tipoExamen: 'EVALUACION DERMATOLOGICA',
      template: 'B',
      controller: EstudioEvaluacionDermatologica,
      dataUrl: 'estudios/'
    },
    ILUMI: {
      id: 4,
      tipoExamen: 'ESTUDIO ILUMINACION INSUFICIENTE',
      template: 'C',
      controller: ExamenIluminacionInsuficiente,
      dataUrl: 'estudios/'
    },
    COLUM: {
      id: 5,
      tipoExamen: 'PROTOCOLO POSICIONES FORZADAS Y GESTOS REPETITIVOS EN LA COLUMNA LUMBOSACRA',
      template: 'G',
      controller: EstudioColumnaLumbosacra,
      dataUrl: 'estudios/'
    },
    PFYGR: {
      id: 8,
      tipoExamen: 'CUESTIONARIO DIRECCIONADO MMSS',
      template: 'D',
      controller: EstudioCuestionarioDireccionadoMMSS,
      dataUrl: 'estudios/'
    },
    HC: {
      id: 9,
      tipoExamen: 'HISTORIA CLINICA',
      template: 'E',
      controller: EstudioHistoriaClinica,
      dataUrl: 'estudios/'
    },
    ORL: {
      id: 10,
      tipoExamen: 'PROTOCOLO SOBRECARGA USO DE LA VOZ',
      template: 'K',
      controller: EstudioSUV,
      dataUrl: 'estudios/'
    },
    AUDIO: {
      id: 14,
      tipoExamen: 'AUDIOMETRIA',
      template: 'F',
      controller: AudiometriaTonal,
      dataUrl: 'estudios/'
    },
    EST: {
      id: 106,
      tipoExamen: 'GENERICO',
      template: 'A',
      controller: ExamenGenerico,
      dataUrl: 'estudios/'
    },
    VMMII: {
      id: 110,
      tipoExamen: 'CUESTIONARIO DIRECCIONADO AUMENTO PRESIÓN VENOSA MMII',
      template: 'H',
      controller: EstudioAumentoPresionVenosa,
      dataUrl: 'estudios/'
    },
    LAB: {
      id: 114,
      tipoExamen: 'ESTUDIO DE LABORATORIO',
      template: 'A',
      controller: ExamenGenerico,
      dataUrl: 'estudios/'
    },
  };
}
